import marketoLogo from 'assets/img/brand/marketo.png';
import hubspot from 'assets/img/brand/hubspot.png';
import salesforceLogo from 'assets/img/brand/salesforce.png';
import slackLogo from 'assets/img/brand/slack.png';
import msTeamsLogo from 'assets/img/brand/ms-teams.png';
import zendeskLogo from 'assets/img/brand/zendesk.png';
import ringleadLogo from 'assets/img/brand/ringlead.png';
import pardotLogo from 'assets/img/brand/pardot.png';
import eloquaLogo from 'assets/img/brand/eloqua.png';
import zohoLogo from 'assets/img/brand/zoho-logo-web.png';
import msDynamicsLogo from 'assets/img/brand/ms-dynamics.png';
import googleCalendarLogo from 'assets/img/brand/google-calendar.png';
import office365Logo from 'assets/img/brand/office-365.png';

export const base64encodedImages = {
  emptyUserImage:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAACXBIWXMAACxLAAAsSwGlPZapAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAsVSURBVHgB7Z3vUhtHEsB7dhcJDIdlwDHnOBdRd3y4T4Yvdwd1V5HiS6oClQs8gckTYJ7A4gksniD4CfAdhX1VCZGunDK5T3Af7ktcKTY2FcdJ7Cg2/yS0O5leSRjLM6tZaWdWOPpVuSg0KxDdM909PT1tgA4dOnTo0KFDh18jBNqc1dzdVBcYlx3XGGOfdox94AR7OfniCVqgQGz2eoG69H+OCXkHevKz6fECnALaUgEodMO1rhJCZ9hHTEBz5NlftzyVnrgJbUxbKWBt/Ys5IMY8ATIG4WETpohDgJuz6Qkb2oy2UIA346l1g32YMAVfjw2ULk1dmcxCGxGpAlZym4k4FK8zwVwDfdhFAul2WQ2RKeBObiNJKeTgJYeqjULZpR//4++TtyBiIlHAWu6LMULNFZAUvmEY0NMdg3gsBl2Wxf6Zx2Ou60KpXIa9vf2tg+JRAgIolPmGzAfpiUWIEO0KqAjfyMlEN71neuBcfx8Tflz4DCFk+QjMxT+O/NbG7ysri2bYyDsgoYyolaBVAbJmp7/vDJwfSHgz34c8OLA4OvpWXvTA7fUvrwGh841+H/NBC1E5Z20KkBE+mpYLQwO+Mx6hLiz9/+FONgZOChxjjBDjbXy9aNCFeud6YkVc9fuZjlNOf/je3/KgGW0KuP3ZvWUwxELoPdMNw0z4frMe7f2Tn57bhefP8dsk7xmRINfWNzLM3FwHMSw66h7XvYM2QAPeBstH+P19vXDxjSGh8I+Yk9357gf4+sG3wISfBJ9VZJkmN6SdvjKRYSvwYxCTjLsHfgpSgnIFYKxPiCn8w1D4F4bOCd//pPAM7J3v4OCwCDKwvNBZ0RhTwjJQsiB8MyHXVj+9mwKNKFdAN5SEThBt/vkBvrxw1j/49jE8ZQoIBDGW/Yanrvwly3zCkmjcNC2tq0CpD1jJ5RJx2r0JAgUkLw17cX09xVKJmZwfPZsvDy2w6b8oG82sfX5vU5Rz0umQLVBIzO2aYSpO8sYGE/0tCp+loSncdChLPx+RrdkPJm0IgOuQBdP0orJXqK6CPGhA6QoQzTI0Pb+7eOEVp1sxO983En7eYfH/h+9N5KFFbn++gQpI8cZYRHROR0SkbAVU437uEkfHWy98FDpGOmLhBzMxMqAi2SpI8cZYRDTHvijfnClzwq7LNkkCfsN2uvX88LQA5bIjeguL0cl42LvV6irKcwcJ+Qg0oEwBBCzuH4C73Hrbf8js/rPdfdGPUpo+Zqv0P4IhlWcTxyhTACVukvc6L83w6PsnIEB97t4wRSnpxAozo6AYhSuAH+KdqVPAPttgCU0PMTKqD06m03/a8vwLhx5KLoNilCjgjs/MsU7k8pHnu3vc56h3oP5nTQfqhKsAl7ojoBglCij7Zjxf2H+MeES2/8LgoMg2q8DmvUiBNluRIY2WZJwIUX4H/UQ/y47qg34DERGpAvAokUc/J0xVCjXOQkQoUYABpnAHeXKj1c3OeF95r3f+638gEzpEvakRoUgBjlABzgkFoKAxJ3T8PiZ8zI6in6CEJkETIltPBM45TJSkItght83yLNyxYunoJUc8wBSQYAfvmAfC12spCtMw3wZNCLOirrMFilHpA2zeizzHi0LHkpOT+SGXUi070dXcRko0FrfiyleAQgVQbhgpe7KFZYqbm9vqw0AXC4C5FN73NmmKfz8oglI3z3sdTZCsEvoSsXdAMUSQdCOCCRQ2yhRQMo6EZX+7+wcgh6u0ZvRfn93D2Z/kjVHiVe4pR5kCZtNptJ953hjufqWOGymkVJohyyDzorEixP4JGlC6ESu7/MNvr75H8rC9L2EqOST3SmUEp2GYh9JVH6RUAdXqY5s3Vni2K+cLKLn21Vc7oUZEmCz0K5UpAWirFVWeimAHHsI/5vGPT734vxHEop9AiFCX3gCh7cfZr+/ugHIFYDEU22lyw7kjdg6AhzES/mDs/vaDGxACd3L/vc5CH1HoqXX2I1qScVgCIhrDsBQP4xuuBGaK7m8/bMkfoPBZeJwR/grqLuq+OaOtOHdt/V6WxdzCqANLVd4cPs+tFXoJApnRkbcCzVIsj+yGwxvMHM75PGZPvTuh/ACmHm3p6OkrkxjT50XjaI6wJugn5px9oZC5//XDle3tR0mQAC8AxunhZiPh49kzRIDWCxqNShVr4GrAJB3WD4kgGF0RkvnDyCXusaVXl+TQjF9Vdg1KnPHp9F+Vpx14aL+iFORyXk0RvFKWGicVgaYmBnszhJoo9BRIgCXrXtV0RERySa+ZG5KojFgML+p1Vb+3MF3MIigKZebADw5LBebIA+yaacFxyGwYJY6tENk11Yo5imcbXR1SRNvcFY70ojZSuUjnXm+hJ0Qg8G5AyejJtEszj8gVgMhepGuR0KqqwyTSqggE7w2zL0zwROkRJAVIsAO3qxiWQhsRyQqobozm2bHjTMidUWSxWRCQB8NZiir8rKFVATj7TNec98vFREA+yr5CWhTgCZ56135S0L7YmObQrQjFl/Q2E3HnICuzG5UFKyfqb9eUJVLaAdAaoipTwL9zXzIbj5nH4OFlfXeUeKxSLyTYDXuX9Yr7h7cePHpccImZ6LLIZZbiTrHcfrJpH0Nptmj0LKoOV0NXQHWXiwcoqSDvw3QDtivoO9PTOCNaoWGzDgRXoekcpCwDZmQ7qJzApmVzdvp9deUpoSqgautR+EmZ52tCP8u5tCcAL+ot7Rrl7PjISFMzc219Y44A/ShIIKCypU1oCqiYHJqVebZWExqkCBc7pOyZ5Uyzgq8n8OZPkUkKRQGNTppqNCN4kDQ1zRJEEWwzt1UiMBumg25ZATLCR/MyWC3CDQQlC6O/vyS1qlpl9dONlGmCjPkMNUpqSQEywsfZjt1QJB1rjQKb9bOqZr0fEn2FkNB6CzWtABnhY7+3oYFgUShb5rZDrHStB1wUeI6aYOmKOISumKPudKtKaCoZhw63kfBx1p9G4SN4QkYIGQdBURmC1dsx97DlUpnAK6Aa52+LxtHeX3xjMPA1o3YR/kmkTu5abPgXSAGNPhAK/9LwkLeDDUqZWCPtJPwaMkpopb9QIBPkVRn4fJBhZnaaET5GO+0ofASvW5FKyYotesY0rU9wxw1NIK2ARo33sM8nNloNDIVbukLNZnmhBCpyuE03/JNWgF81MUY7gWP8KmXDWoBTACqh7Pp0XWyy4Z+UAryCVp/Ge0GjnRrYdrhdTQ8PLLcPu+FfQwVUnJA7JxrHes5mwZ7PcMooGcUMiP1BKugqkFgBBtr9JG8ETU/AHe4xp23218CrV44jNkVBV0FDBYhmP5qes03afe/nArkFpxTfVmcBV4GvAqr3qJK8sQFB20lZRkfe1HIJThVYYyQaM42ueZDEVwEs8uGGnTj7+5oJOY9/sJ6enCrxb/hHU7L7AqECql2vUrwxTDNInmBxYee1Wi5Bq8ZnFSSqbS8bIpSiX9vJgRMdTprBMKxNeA2orgKbOyjZ9lKoAJH58avVl6bs/gyvCViRIRgakzFDPnaE362ktxXbX2V3txxpOWCYuK7QnyV64SgJDfCZyvzDCCyC2pdstsGDzRh7p/BobDV3F14HvGZPlJ9ULpaLDVeAny2xgROC4g33QqOLdP4kTbBy8CtApt+Q0ASxnMepjtPbAFum35BQAYZBsj7p1w6NIEZG5jGhAjD9CtQ4dcmy9oDelO3667ubqvx/K17iyYYOUmC6eurdyTnZ56XOhHFXzMKtFDsVuloJT/VcqDtF2J7PNNzlqG/cdOjQoUOHDh06dOggwS+zyKT/IXV0UgAAAABJRU5ErkJggg==',
  emptyCompanyImage:
    'data:image/png;base64,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',
};

export const PricingInfo = {
  appUsers: currentAllowedUsers =>
    `Your current plan allows ${currentAllowedUsers} users. Upgrade to add more users and access other exclusive features.`,
  clickBasedTrigger: 'Upgrade to Click Based Chat access other exclusive features.',
  teams: 'Upgrade to Create Team and access other exclusive features.',
  officeHours: 'Upgrade to Office Hours and access other exclusive features.',
  abTesting: 'Upgrade to add A/B Testing variant and access other exclusive features.',
  zendesk: 'Upgrade to connect Zendesk and access other exclusive features',
  integrationsRouting: 'Upgrade to Advanced Routing and access other exclusive features',
  salesforceServiceCloud:
    'Upgrade to connect Salesforce service cloud and access other exclusive features',
  formFactor: 'Upgrade to add buttons in greeting message and access other exclusive features.',
};

export const BOT_FIELDS = {
  STEPS: {
    TEXT: 'text',
    BUTTONS: 'buttons',
    INPUT: 'input',
    PLAIN_INPUT: 'plainInput',
    LINK: 'link',
    CONNECT_TO_HUMAN: 'app',
    NOTIFICATION: 'notification',
    ZENDESK_CREATE_TICKET: 'zendeskCreateTicket',
    ZENDESK_SEARCH_KNOWLEDGE_BASE: 'zendeskSearchKnowledgeBase',
    SERVICE_CLOUD_CREATE_CASE: 'serviceCloudCreateTicket',
    SERVICE_CLOUD_KNOWLEDGE_BASE: 'serviceCloudKnowledgeBase',
    REDIRECT_BUTTON: 'nextStateFromResponse',
    REDIRECT_PATH: 'nextState',
    CSAT: 'feedback',
    NATIVE_CALENDAR: 'calendar',
  },
  REDIRECT: {
    BUTTONS: 'fromResponse',
    GO_TO_PATH: 'nextState',
    ALERTS: 'alerts',
    SLACK: 'slack',
    APP: 'app',
  },
};

export const PERSONALIZATION_HELPER_TYPES = {
  EDIT: 'edit',
  UPDATE: 'update',
  EDIT_EVENT: 'personalizationEdit',
};

export const PREVIEW_CONSTANTS = {
  iframeId: 'insent-iframe',
  iframeResize: 'iframe-resize',
  initialData: 'initial-data',
  insentUserId: 'insent-user-id',
  simulatorUserId: 'simulator-user-id',
  insentSimulator: 'insent-simulator',
};

export const DURATION = {
  FORM_TIMEOUT: 60000,
  EXTRLONG: 7000,
  LONG: 5000,
  MEDIUM: 3000,
  SHORT: 1000,
};

export const CONVERSATION_STATUS = {
  open: 'Open',
  close: 'Closed',
  pending: 'Pending',
};

export const INTEGRATIONS = {
  MARKETO: {
    KEY: 'marketo',
    NAME: 'Marketo',
    IMAGE: marketoLogo,
  },
  HUBSPOT: {
    KEY: 'hubspot',
    NAME: 'Hubspot',
    IMAGE: hubspot,
  },
  SALESFORCE: {
    KEY: 'salesforce',
    NAME: 'Salesforce',
    IMAGE: salesforceLogo,
  },
  SLACK: {
    KEY: 'slack',
    NAME: 'Slack',
    IMAGE: slackLogo,
  },
  MS_TEAMS: {
    KEY: 'msteams',
    NAME: 'Microsoft Teams',
    IMAGE: msTeamsLogo,
  },
  ZENDESK: {
    KEY: 'zendesk',
    NAME: 'Zendesk',
    IMAGE: zendeskLogo,
    CREDENTIALS_MODEL: {
      FIELD_NAME: 'Domain Name',
      PLACEHOLDER: 'Enter domain name',
    },
  },
  RINGLEAD: {
    KEY: 'ringlead',
    NAME: 'RingLead',
    IMAGE: ringleadLogo,
  },
  PARDOT: {
    KEY: 'pardot',
    NAME: 'Pardot',
    IMAGE: pardotLogo,
    CREDENTIALS_MODEL: {
      FIELD_NAME: 'Business Unit ID',
      PLACEHOLDER: 'Enter Business Unit ID',
    },
  },
  ELOQUA: {
    KEY: 'eloqua',
    NAME: 'Eloqua',
    IMAGE: eloquaLogo,
  },
  ZOHO: {
    KEY: 'zoho',
    NAME: 'Zoho',
    IMAGE: zohoLogo,
  },
  MS_DYNAMICS: {
    KEY: 'msdynamics',
    NAME: 'Microsoft Dynamics CRM',
    IMAGE: msDynamicsLogo,
    CREDENTIALS_MODEL: {
      FIELD_NAME: 'Organization name',
      PLACEHOLDER: 'acmecrop.crm',
    },
  },
  GOOGLE_CALENDAR: {
    IMAGE: googleCalendarLogo,
    NAME: 'Google Calendar',
    DESCRIPTION: 'Google and Gmail Calendars',
  },
  MICROSOFT_CALENDAR: {
    IMAGE: office365Logo,
    NAME: 'Office 365',
    DESCRIPTION: 'Office 365, Outlook.com, live.com or hotmail calendar',
  },
};

export const PUSHER_EVENT_TYPES = {
  VISITOR_STATUS_CHANGE: 'visitor-status-change',
  NEW_MESSAGE: 'new-message',
  CONVERSATION_STATUS_CHANGE: 'conversation-status-change',
  CONVERSATION_MEMBER_JOIN: 'conversation-member-join',
  CONVERSATION_MEMBER_LEAVE: 'conversation-member-leave',
  CONVERSATION_READ: 'conversation-read',
  CONVERSATION_STAR: 'conversation-star',
  CONVERSATION_ARCHIVE: 'conversation-archive',
  CONVERSATION_VISITOR_READ: 'conversation-visitor-read',
  CONVERSATION_VISITOR_DELIVERED: 'conversation-visitor-delivered',
  APPUSER_AVAILABLE: 'appuser-available',
  TAKE_CONVERSATION: 'take-conversation',
  CANCEL_TAKE_CONVERSATION: 'cancel-take-conversation',
  MESSAGE_UPDATE: 'message-update',
  ONLINE_CONVERSATION_COUNT_UPDATE: 'online-conversations-count-update',
  VISITOR_BLOCKED_STATUS_CHANGE: 'visitor-blocked-status-change',
};

export const MOMENT_TIME_LIMIT = 10000000000;

export const NOTIFICATION = {
  TYPE: {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
  },
  VARIANTS: {
    DEFAULT: 'default',
    AGENT_REQUEST: 'agentRequest',
    PASSWORD_EXPIRY: 'passwordExpiry',
  },
};

export const WEEK_PICKER_OPTIONS = [
  {
    label: 'Everyday',
    value: 'everyday',
  },
  {
    label: 'Weekdays',
    value: 'weekdays',
  },
  {
    label: 'Sunday',
    value: 'sunday',
  },
  {
    label: 'Monday',
    value: 'monday',
  },
  {
    label: 'Tuesday',
    value: 'tuesday',
  },
  {
    label: 'Wednesday',
    value: 'wednesday',
  },
  {
    label: 'Thursday',
    value: 'thursday',
  },
  {
    label: 'Friday',
    value: 'friday',
  },
  {
    label: 'Saturday',
    value: 'saturday',
  },
];

export const TIME_PICKER_FROM_OPTIONS = [
  { label: '12:00 AM', value: 0 },
  { label: '12:30 AM', value: 1800 },
  { label: '01:00 AM', value: 3600 },
  { label: '01:30 AM', value: 5400 },
  { label: '02:00 AM', value: 7200 },
  { label: '02:30 AM', value: 9000 },
  { label: '03:00 AM', value: 10800 },
  { label: '03:30 AM', value: 12600 },
  { label: '04:00 AM', value: 14400 },
  { label: '04:30 AM', value: 16200 },
  { label: '05:00 AM', value: 18000 },
  { label: '05:30 AM', value: 19800 },
  { label: '06:00 AM', value: 21600 },
  { label: '06:30 AM', value: 23400 },
  { label: '07:00 AM', value: 25200 },
  { label: '07:30 AM', value: 27000 },
  { label: '08:00 AM', value: 28800 },
  { label: '08:30 AM', value: 30600 },
  { label: '09:00 AM', value: 32400 },
  { label: '09:30 AM', value: 34200 },
  { label: '10:00 AM', value: 36000 },
  { label: '10:30 AM', value: 37800 },
  { label: '11:00 AM', value: 39600 },
  { label: '11:30 AM', value: 41400 },
  { label: '12:00 PM', value: 43200 },
  { label: '12:30 PM', value: 45000 },
  { label: '01:00 PM', value: 46800 },
  { label: '01:30 PM', value: 48600 },
  { label: '02:00 PM', value: 50400 },
  { label: '02:30 PM', value: 52200 },
  { label: '03:00 PM', value: 54000 },
  { label: '03:30 PM', value: 55800 },
  { label: '04:00 PM', value: 57600 },
  { label: '04:30 PM', value: 59400 },
  { label: '05:00 PM', value: 61200 },
  { label: '05:30 PM', value: 63000 },
  { label: '06:00 PM', value: 64800 },
  { label: '06:30 PM', value: 66600 },
  { label: '07:00 PM', value: 68400 },
  { label: '07:30 PM', value: 70200 },
  { label: '08:00 PM', value: 72000 },
  { label: '08:30 PM', value: 73800 },
  { label: '09:00 PM', value: 75600 },
  { label: '09:30 PM', value: 77400 },
  { label: '10:00 PM', value: 79200 },
  { label: '10:30 PM', value: 81000 },
  { label: '11:00 PM', value: 82800 },
  { label: '11:30 PM', value: 84600 },
];

export const TIME_PICKER_TO_OPTIONS = [
  ...TIME_PICKER_FROM_OPTIONS.slice(1),
  { label: '12:00 AM', value: 86400 },
];

export const PERMISSION_STRUCTURE = {
  inbox: {
    name: 'Inbox',
    permissions: [],
  },
  conversations: {
    name: 'Conversations',
    permissions: [],
  },
  analytics: {
    name: 'Analytics',
    permissions: [],
  },
  settings: {
    name: 'Settings',
    resources: {
      integrations: {
        name: 'Integrations',
        permissions: [],
      },
      team: {
        name: 'Team',
        resources: {
          users: {
            name: 'Users',
            permissions: [],
          },
          teams: {
            name: 'Teams',
            permissions: [],
          },
          userRoles: {
            name: 'Roles',
            permissions: [],
          },
        },
      },
      widgetSettings: {
        name: 'Widget Settings',
        permissions: [],
      },
    },
  },
};
